var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMissionMeetinginline = function SvgMissionMeetinginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Meeting"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.833 14.083A4.346 4.346 0 0 1 32.5 9.75a4.346 4.346 0 0 1 4.333-4.333 4.346 4.346 0 0 1 4.334 4.333 4.346 4.346 0 0 1-4.334 4.333Z",
    fill: "#1C385E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.5 29.25h3.25v15.708a1.626 1.626 0 0 1-3.25 0V29.25Z",
    fill: "#1C385E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.917 29.25h3.25v15.708a1.626 1.626 0 0 1-3.25 0V29.25Z",
    fill: "#1C385E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "m24.127 28.86 6.451-9.216a5.417 5.417 0 0 1 4.438-2.31h2.9a5.417 5.417 0 0 1 5.417 5.416v10.292a1.621 1.621 0 0 1-3.15.542h-2.266a1.084 1.084 0 0 0-2.167 0H32.5v-9.029c0-.613-.789-.861-1.14-.36l-4.57 6.529a1.624 1.624 0 0 1-2.263.398 1.623 1.623 0 0 1-.4-2.262Z",
    fill: "#1C385E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.083 14.083A4.346 4.346 0 0 1 9.75 9.75a4.346 4.346 0 0 1 4.333-4.333 4.346 4.346 0 0 1 4.334 4.333 4.346 4.346 0 0 1-4.334 4.333Z",
    fill: "#F12B3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.417 29.25h-3.25v15.708a1.626 1.626 0 0 0 3.25 0V29.25Z",
    fill: "#F12B3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13 29.25H9.75v15.708a1.626 1.626 0 0 0 3.25 0V29.25Z",
    fill: "#F12B3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "m26.79 28.86-6.451-9.216a5.415 5.415 0 0 0-4.438-2.31H13a5.417 5.417 0 0 0-5.417 5.416v10.292a1.621 1.621 0 0 0 3.15.542H13a1.084 1.084 0 0 1 2.167 0h3.25v-9.029c0-.613.788-.861 1.14-.36l4.57 6.529a1.624 1.624 0 0 0 2.263.398 1.623 1.623 0 0 0 .4-2.262Z",
    fill: "#F12B3B"
  }))));
};
export default SvgMissionMeetinginline;